module.exports = __webpack_public_path__ + "static/media/Veronica.2760708d.png";